import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { FaHeart } from "react-icons/fa";
import { FaStar } from 'react-icons/fa6';

const About = () => {
  const [isDetailsVisible, setDetailsVisibility] = useState(false);

  const toggleDetails = () => {
    setDetailsVisibility(!isDetailsVisible);
  };

  return (
    <section className="about">
      <div className="about-content">
        <br />
        <h2 className='artist-info'>Studio <span className='artist'>Artist</span></h2>
        <hr className='line' />
        <br />
      <div className='about-context'>
      <p>
        Hi, my name is Isabel!
        <br /> I'm a PDX based licensed manicurist 
        <br />specializing in Korean and Japanese
        <br />
        gel extensions, soft gel overlays, & gel nail art.
      </p>
      <p>For inquiries/bookings,
        <br />please contact me on either
        <br /> my Instagram or contact form.
      </p>

      <p>
        There is a <strong>non-refundable</strong> deposit of $50 
        <br />that goes towards the total price of your service. 
      </p>
      <FaStar className='star-icon' /><FaStar className='star-icon' /><FaStar className='star-icon' /><FaStar className='star-icon' /><FaStar className='star-icon' /><FaStar className='star-icon' /><FaStar className='star-icon' /><FaStar className='star-icon' />
      </div>
      </div>
    </section>
    
    
  );
};

export default About;
